import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import {Translate} from 'react-redux-i18n';
import {AbstractFormComponent, Icon, TextCheckbox} from 'front-onceforall-core';
import {requiredValidator} from 'front-onceforall-core/dist/utils/validators';
import enrollmentService from '../../services/enrollment';
import * as snackbarsActions from '../../actions/snackbars';
import {openOrSaveFile} from '../../utils/http';
import authenticationService from '../../services/authentication/AuthenticationService';
import {captureError} from '../../utils/log';

export class GenerateAccessCodeForm extends AbstractFormComponent {
  componentDidMount() {
    this.setState({loading: false});
  }

  getFormData() {
    return {
      organisationName: '',
      additionalInformation: '',
      isResponseToAccessCode: false,
      tenderReference: ''
    };
  }

  getFormValidators() {
    return {
      organisationName: requiredValidator,
      tenderReference: this.tenderReferenceValidator.bind(this)
    };
  }

  tenderReferenceValidator(value) {
    if (this.state.formData.isResponseToAccessCode) {
      return requiredValidator(value);
    }

    return null;
  }

  handleChangeCallback(name) {
    // If isResponseToAccessCode change value, we trigger the validation of all fields
    if (name === 'isResponseToAccessCode') {
      this.validateAllFields();
    }
  }

  handleSubmitCallback() {
    const {formData} = this.state;
    if (!formData.isResponseToAccessCode) {
      formData.tenderReference = null;
    }

    enrollmentService.general.createAccessCode(this.props.organisation.organisationId, formData)
      .then(invitation => {
        authenticationService.authRedirect(enrollmentService.general.downloadAccessCode(this.props.organisation.organisationId, invitation.id))
          .then(authUrl => {
            openOrSaveFile(authUrl, 'pdf');
            this.props.onClose();
          });
      })
      .catch(error => {
        captureError('Error while creating access code', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
        this.props.onClose();
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        {this.state.loading && <div className="loading-overlay"/>}
        <h2>
          <Translate value="client.accessCode.generateText"/>
        </h2>
        <div
          className="box flex-container mb-4"
          data-id="info-box"
        >
          <span className="flex-shrink-0">
            <Icon
              icon="info"
              size={20}
            />
          </span>
          <span>
            <Translate value="client.accessCode.generateWarning"/>
          </span>
        </div>
        <TextField
          label={this.getFieldLabel('client.accessCode.clientOrgName', true)}
          value={this.state.formData.organisationName}
          onChange={this.handleChange('organisationName')}
          error={this.isOnError('organisationName')}
          helperText={this.helperText('organisationName')}
          id="organisationName"
          name="organisationName"
        />
        <TextField
          label={this.getFieldLabel('client.accessCode.additionalInformation')}
          value={this.state.formData.additionalInformation}
          onChange={this.handleChange('additionalInformation')}
          id="additionalInformation"
          name="additionalInformation"
        />
        <TextCheckbox
          label={this.getFieldLabel('client.accessCode.responseToAccessCode')}
          checked={this.state.formData.isResponseToAccessCode}
          onChange={this.handleChange('isResponseToAccessCode')}
          name="isResponseToAccessCode"
        />
        {this.state.formData.isResponseToAccessCode && <TextField
          label={this.getFieldLabel('client.accessCode.tenderReference', true)}
          value={this.state.formData.tenderReference}
          onChange={this.handleChange('tenderReference')}
          error={this.isOnError('tenderReference')}
          helperText={this.helperText('tenderReference')}
          id="tenderReference"
          name="tenderReference"
        />}

        <div className="actions col-12 flex-container space-between">
          <button
            type="button"
            className="large secondary"
            onClick={this.props.onClose}
            data-id="cancel"
          >
            <Translate value="action.cancel"/>
          </button>
          <button
            className="large primary flex-container"
            type="submit"
            disabled={this.state.submitting}
          >
            <Icon icon={this.state.submitting ? 'loader' : 'check'}/>
            <Translate value="action.confirm"/>
          </button>
        </div>
      </form>
    );
  }
}

GenerateAccessCodeForm.propTypes = {
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GenerateAccessCodeForm);
